import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@babackapp/ui/components/popover";
import type { ElementType, PropsWithChildren } from "react";

export interface FacetedFilterValueProps extends PropsWithChildren {
  icons: ElementType[];
  label: string;
}

export default function FacetedFilterValue(props: FacetedFilterValueProps) {
  const { children, icons, label } = props;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div
          className={
            "bg-background hover:bg-accent hover:text-accent-foreground px-2 h-full flex flex-row items-center cursor-pointer text-sm font-medium gap-1"
          }
        >
          <div className={"flex flex-row items-center"}>
            {icons.map((Icon, index) => {
              return (
                <div
                  key={index}
                  className={
                    "[&:not(:first-child)]:ml-[-3.5px] bg-background rounded-full"
                  }
                >
                  <Icon className={"h-4 w-4"} />
                </div>
              );
            })}
          </div>
          <span>{label}</span>
        </div>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start">
        {children}
      </PopoverContent>
    </Popover>
  );
}
